import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, BoxIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
interface ServiceCardProps {
  title: string;
  description: string;
  icon: LucideIcon;
  delay?: number;
  path?: string;
}
export function ServiceCard({
  title,
  description,
  icon: Icon,
  delay = 0,
  path = '/services'
}: ServiceCardProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 30
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-50px'
  }} transition={{
    duration: 0.5,
    delay
  }} className="bg-white border border-gray-100 rounded-xl p-8 shadow-sm hover:shadow-xl transition-all duration-300 group relative overflow-hidden" data-id="element-176">
      <div className="absolute top-0 left-0 w-1 h-0 bg-brand-green group-hover:h-full transition-all duration-300" data-id="element-177"></div>

      <div className="w-14 h-14 bg-brand-light rounded-lg flex items-center justify-center mb-6 group-hover:bg-brand-green/10 transition-colors" data-id="element-178">
        <Icon className="w-7 h-7 text-brand-dark group-hover:text-brand-green transition-colors" data-id="element-179" />
      </div>

      <h3 className="text-xl font-heading font-bold text-brand-dark mb-3 group-hover:text-brand-green transition-colors" data-id="element-180">
        {title}
      </h3>

      <p className="text-gray-600 mb-6 line-clamp-3 leading-relaxed" data-id="element-181">
        {description}
      </p>

      <Link to={path} className="inline-flex items-center text-sm font-bold text-brand-dark group-hover:text-brand-green transition-colors mt-auto" data-id="element-182">
        LEARN MORE
        <ArrowRight className="ml-2 w-4 h-4 group-hover:translate-x-2 transition-transform" data-id="element-183" />
      </Link>
    </motion.div>;
}